import Vue from 'vue';

import Tabs from '@/components/tabs/Tabs.vue';

export default Vue.extend({
  name: 'TabsMixin',

  components: {
    Tabs,
  },

  data(): {
    // TODO: 現状 index は未使用(tabIndexes[0]のみ利用)なので後々修正した方が良いかと
    tabIndexes: number[];
  } {
    return {
      tabIndexes: [],
    };
  },

  methods: {
    // .vueで利用する際は()省略不可（データ更新時に画面側で再呼び出しされなくなるため）
    tabIndex(index?: number): number {
      return index === undefined ? this.tabIndexes[0] : this.tabIndexes[index];
    },
    // .vueで利用する際は()省略不可（データ更新時に画面側で再呼び出しされなくなるため）
    tabComponent(index?: number): string {
      const tabIndex = index === undefined ? this.tabIndexes[0] : this.tabIndexes[index];
      if (tabIndex === undefined) return '';
      return index === undefined ? `tab${tabIndex}` : `tab${index}_${tabIndex}`;
    },
    setTabIndex(index: number, tabIndex: number): void {
      this.$set(this.tabIndexes, index, tabIndex);
    },
  },
});
